import MainMenu from "./modules/MainMenu";
import MapDestinations from "./modules/MapDestinations";
import BlockLink from "./modules/BlockLink";
import ImagePopup from "./modules/ImagePopup";
import Popup from "./modules/Popup";

document.addEventListener( 'DOMContentLoaded', () => {
    // parse translations as json
    // ctheme.translations = JSON.parse(ctheme.translations);
    document.querySelector('html').classList.remove('no-js');

    new MainMenu();
    new Popup();
    new MapDestinations('#map-destinations');
    new BlockLink();
    new ImagePopup();
});